import React, { useEffect, useState } from "react";
import { FaRedoAlt } from "react-icons/fa";

type RefreshActionButtonProps = {
  ButtonComponent?: React.ElementType;
  className?: string;
  disabled?: boolean;
  iconSize?: number;
  isLoading?: boolean;
  label: string;
  loadingLabel?: string;
  onClick: () => void | Promise<unknown>;
  type?: "button" | "submit" | "reset";
};

export const RefreshActionButton: React.FC<RefreshActionButtonProps> = ({
  ButtonComponent = "button",
  className,
  disabled = false,
  iconSize = 12,
  isLoading = false,
  label,
  loadingLabel = "Refreshing...",
  onClick,
  type = "button",
}) => {
  const [isPressed, setPressed] = useState(false);

  useEffect(() => {
    if (!isPressed || isLoading) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setPressed(false), 240);
    return () => window.clearTimeout(timeoutId);
  }, [isLoading, isPressed]);

  const refreshState = isLoading ? "loading" : isPressed ? "pressed" : "idle";

  return (
    <ButtonComponent
      aria-busy={isLoading || undefined}
      className={["brand-refresh-button", className].filter(Boolean).join(" ")}
      data-refresh-state={refreshState}
      disabled={disabled || isLoading}
      onClick={() => {
        setPressed(true);
        void Promise.resolve(onClick());
      }}
      type={type}
    >
      <span aria-hidden="true" className="brand-refresh-icon">
        <FaRedoAlt size={iconSize} />
      </span>
      {isLoading ? loadingLabel : label}
    </ButtonComponent>
  );
};

export default RefreshActionButton;
